"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alias = void 0;
var Alias = (function () {
    function Alias(alias) {
        this.unparsed = alias;
        this.parsed = Alias.parse(this.unparsed);
    }
    Alias.parse = function (unparsed) {
        return Object.keys(unparsed).reduce(function (prev, curr) {
            var _a;
            var parsed = Alias.toPosix(unparsed[curr]);
            return __assign(__assign({}, prev), (_a = {}, _a[curr] = parsed.charAt(parsed.length - 1) === '/'
                ? parsed.slice(0, parsed.length - 1)
                : parsed, _a));
        }, {});
    };
    Alias.prototype.getPath = function (alias) {
        return this.parsed[alias];
    };
    Alias.prototype.resolve = function (url) {
        for (var alias in this.parsed) {
            if (url.startsWith(alias)) {
                return this.parsed[alias] + url.replace(alias, '');
            }
        }
        return undefined;
    };
    Alias.toPosix = function (windowsLikePath) {
        return windowsLikePath.replace(/\\/g, '/').replace(/^[a-zA-Z]:/, '');
    };
    return Alias;
}());
exports.Alias = Alias;
//# sourceMappingURL=alias.js.map